import RoleComponent from "./RoleComponent";

const AdminRolesComponent = () => {
  return (
    <section className="min-h-screen">
      <h2 className="text-2xl text-left font-semibold mb-4">Manage Roles</h2>
      <p className="text-red-900 font-semibold text-center bg-red-100 p-5 max-w-2xl mx-auto rounded mb-6">
        This is where you can manage roles<br/>
        <hr className="border-red-200 mt-2 mb-1"/>
        <small>Avoid adding/editing/removing roles if you are not familiar with what you are doing.Consult first before acting.</small>
      </p>

      <RoleComponent/>
      
    </section>
  );
};  

export default AdminRolesComponent;